import { useNavigate } from 'react-router-dom';

import LogoImage from '../../../assets/images/Logo_blue_2x.svg';
import EmailIcon from '../../../assets/images/social/envelopeSimple.svg';
import WhatsAppIcon from '../../../assets/images/social/whatsappLogo.svg';

import InstagramIcon from '../../../assets/images/social/instagram.svg';
import LinkedinIcon from '../../../assets/images/social/linkedin.svg';
import TwitterIcon from '../../../assets/images/social/twitter.svg';
import FacebookIcon from '../../../assets/images/social/facebook.svg';
import TiktokIcon from '../../../assets/images/social/tiktok.svg';

import GooglePlayLogo from '../../../assets/images/landing-page/googlePlayLogo.svg';
import AppStoreLogo from '../../../assets/images/landing-page/appStoreLogo.svg';

const appLinks = [
  {
    icon: GooglePlayLogo,
    platform: 'Google Play',
    url: 'https://play.google.com/store/apps/details?id=com.flowexpay.app',
  },
  {
    icon: AppStoreLogo,
    platform: 'App Store',
    url: 'https://apps.apple.com/app/flowexpay/id6762288494',
  },
];

const socials = [
  {
    icon: InstagramIcon,
    url: 'https://www.instagram.com/flowexpay/?igsh=OGhweTVucm5rbXZz#',
    alt: 'Instagram Icon',
    customClass: 'w-7 h-7',
  },
  {
    icon: LinkedinIcon,
    url: 'https://www.linkedin.com/company/flowex-pay/',
    alt: 'Linkedin Icon',
    customClass: 'w-9 h-9',
  },
  {
    icon: TwitterIcon,
    url: 'https://x.com/cfoflowexpay?s=11&t=VB19UrykRUBS1ejOQZvcBw',
    alt: 'Twitter Icon',
    customClass: 'w-6.5 h-6.5',
  },
  {
    icon: FacebookIcon,
    url: 'https://www.facebook.com/profile.php?id=61575934179077',
    alt: 'Facebook Icon',
    customClass: 'w-9.5 h-9.5',
  },
  {
    icon: TiktokIcon,
    url: 'https://www.tiktok.com/@flowexpay?_t=ZS-8xih87YLIFG&_r=1',
    alt: 'Tiktok Icon',
    customClass: 'w-8.5 h-8.5',
  },
];

export default function Footer() {
  const navigate = useNavigate();

  const goToPage = (path) => {
    navigate(path);
  };

  return (
    <footer className="bg-[#FDFDFD] px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 py-6 sm:py-8 lg:py-10">
      <div className="w-full">
        {/* Mobile Layout */}
        <div className="block md:hidden space-y-6">
          {/* Logo */}
          <div className="flex justify-center">
            <img
              src={LogoImage}
              alt="Logo Image"
              className="w-32 h-14 sm:w-40 sm:h-16 md:w-44 md:h-20 object-contain"
            />
          </div>

          {/* Legal Links */}
          <div className="space-y-3 text-center">
            <button
              onClick={() => goToPage('/termsOfServices')}
              className="block cursor-pointer w-full text-sm sm:text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
            >
              Términos y condiciones
            </button>
            <button
              onClick={() => goToPage('/policy')}
              className="block cursor-pointer w-full text-sm sm:text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
            >
              Política de protección de datos
            </button>
          </div>

          {/* Contact Section */}
          <div className="space-y-4">
            <h3 className="text-base sm:text-lg text-[#181D27] font-medium text-center">
              Contacto
            </h3>

            <div className="space-y-3">
              <div className="flex items-center justify-center space-x-2">
                <img
                  src={EmailIcon}
                  alt="Email Icon"
                  className="w-4 h-4 sm:w-5 sm:h-5 mt-[3px] flex-shrink-0"
                />
                <a
                  href="mailto:soporte@flowexpay.com"
                  className="text-sm sm:text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors break-all"
                >
                  soporte@flowexpay.com
                </a>
              </div>

              <div className="flex items-center justify-center space-x-2">
                <img
                  src={WhatsAppIcon}
                  alt="WhatsApp Icon"
                  className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0"
                />
                <a
                  href="tel:+573204088142"
                  className="text-sm sm:text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                >
                  +57 3204088142
                </a>
              </div>
            </div>
          </div>

          {/* App Download Links */}
          <div className="flex items-center justify-center gap-3">
            {appLinks.map((item, idx) => (
              <a
                key={idx}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 px-4 py-2 bg-[#092F7B] rounded-lg hover:bg-[#0a3a96] transition-colors duration-200"
              >
                <img src={item.icon} alt={item.platform} className="w-5 h-5" />
                <span className="font-[poppins] text-xs text-white font-medium">{item.platform}</span>
              </a>
            ))}
          </div>

          {/* Social Media */}
          <div className="flex items-center justify-center space-x-4 xl:space-x-6 flex-shrink-0">
            {socials.map((item, idx) => (
              <a
                key={idx}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform duration-200"
              >
                <img
                  src={item.icon}
                  alt={item.alt}
                  className={`${item.customClass}`}
                />
              </a>
            ))}
          </div>
        </div>

        {/* Tablet Layout */}
        <div className="hidden md:block lg:hidden">
          <div className="flex justify-between gap-8">
            <div className="space-y-6">
              <img
                src={LogoImage}
                alt="Logo Image"
                className="w-44 h-20 object-contain"
              />
            </div>

            <div className="space-y-3">
              <button
                onClick={() => goToPage('/termsOfServices')}
                className="block cursor-pointer text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
              >
                Términos y condiciones
              </button>
              <button
                onClick={() => goToPage('/policy')}
                className="block cursor-pointer text-left text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
              >
                Política de protección de datos
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <h3 className="text-base text-[#181D27] font-medium leading-[1.45] mb-4">
                  Contacto
                </h3>

                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <img
                      src={EmailIcon}
                      alt="Email Icon"
                      className="w-5 h-5 flex-shrink-0"
                    />
                    <a
                      href="mailto:soporte@flowexpay.com"
                      className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                    >
                      soporte@flowexpay.com
                    </a>
                  </div>

                  <div className="flex items-center space-x-2">
                    <img
                      src={WhatsAppIcon}
                      alt="WhatsApp Icon"
                      className="w-5 h-5 flex-shrink-0"
                    />
                    <a
                      href="tel:+573204088142"
                      className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                    >
                      +57 3204088142
                    </a>
                  </div>
                </div>
              </div>

              {/* Social Media */}
              <div className="flex items-center space-x-4 xl:space-x-6 flex-shrink-0">
                {socials.map((item, idx) => (
                  <a
                    key={idx}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:scale-110 transition-transform duration-200"
                  >
                    <img
                      src={item.icon}
                      alt={item.alt}
                      className={`${item.customClass}`}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Midul device Layout */}
        <div className="hidden lg:block xl:hidden">
          <div className="flex justify-between gap-8 items-start">
            <img
              src={LogoImage}
              alt="Logo Image"
              className="w-44 h-20 object-contain"
            />

            <div className="space-y-3 ">
              <button
                onClick={() => goToPage('/termsOfServices')}
                className="block cursor-pointer text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
              >
                Términos y condiciones
              </button>
              <button
                onClick={() => goToPage('/policy')}
                className="block cursor-pointer text-left text-base text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors hover:underline"
              >
                Política de protección de datos
              </button>
            </div>

            <div>
              <h3 className="text-base text-[#181D27] font-medium leading-[1.45] mb-4">
                Contacto
              </h3>

              <div className="space-y-3">
                <div className="flex items-center space-x-2">
                  <img
                    src={EmailIcon}
                    alt="Email Icon"
                    className="w-5 h-5 flex-shrink-0"
                  />
                  <a
                    href="mailto:soporte@flowexpay.com"
                    className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                  >
                    soporte@flowexpay.com
                  </a>
                </div>

                <div className="flex items-center space-x-2">
                  <img
                    src={WhatsAppIcon}
                    alt="WhatsApp Icon"
                    className="w-5 h-5 flex-shrink-0"
                  />
                  <a
                    href="tel:+573204088142"
                    className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                  >
                    +57 3204088142
                  </a>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4 xl:space-x-6 flex-shrink-0">
              {socials.map((item, idx) => (
                <a
                  key={idx}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-110 transition-transform duration-200"
                >
                  <img
                    src={item.icon}
                    alt={item.alt}
                    className={`${item.customClass}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Desktop Layout (xl and above) */}
        <div className="hidden xl:block">
          <div className="flex justify-between items-start gap-8">
            {/* Left Section */}
            <div className="flex items-start gap-6 xl:gap-8 flex-1 min-w-0">
              <img
                src={LogoImage}
                alt="Logo Image"
                className="w-44 h-20 object-contain flex-shrink-0"
              />

              <button
                onClick={() => goToPage('/termsOfServices')}
                className="text-base cursor-pointer text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors whitespace-nowrap hover:underline"
              >
                Términos y condiciones
              </button>

              <button
                onClick={() => goToPage('/policy')}
                className="text-base cursor-pointer text-[#181D27] font-medium leading-[1.45] hover:text-[#092F7B] transition-colors whitespace-nowrap hover:underline"
              >
                Política de protección de datos
              </button>

              <div className="flex-shrink-0">
                <h3 className="text-base text-[#181D27] font-medium leading-[1.45] mb-3">
                  Contacto
                </h3>

                <div className="space-y-2">
                  <div className="flex items-center space-x-2">
                    <img
                      src={EmailIcon}
                      alt="Email Icon"
                      className="w-5 h-5 flex-shrink-0"
                    />
                    <a
                      href="mailto:soporte@flowexpay.com"
                      className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                    >
                      soporte@flowexpay.com
                    </a>
                  </div>

                  <div className="flex items-center space-x-2">
                    <img
                      src={WhatsAppIcon}
                      alt="WhatsApp Icon"
                      className="w-5 h-5 flex-shrink-0"
                    />
                    <a
                      href="tel:+573204088142"
                      className="text-base text-[#717680] font-normal leading-[1.45] hover:text-[#092F7B] transition-colors"
                    >
                      +57 3204088142
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-center space-x-4 xl:space-x-6 flex-shrink-0">
              {socials.map((item, idx) => (
                <a
                  key={idx}
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:scale-110 transition-transform duration-200"
                >
                  <img
                    src={item.icon}
                    alt={item.alt}
                    className={`${item.customClass}`}
                  />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
